module.exports = __webpack_public_path__ + "img/05.66cbe12b.png";